import React, { useState } from 'react';

import { LazyImage } from "components/Image/Index";
import { ScrollPercentage } from 'react-scroll-percentage';

import { useSpring, a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

import classNames from 'classnames';
import * as fromProjects from 'store/Projects';
import { FullQuotation, IQuotation } from 'components/Quotations/FullQuotation/FullQuotation';

interface IProps {
  animationReady: boolean;
  content: fromProjects.IContentQuotationFullBleedImage;
  quotationBackgroundShade: fromProjects.IBackgroundShadeTypes;
}

export const FullBleedImage: React.FC<IProps> = ({ animationReady, content, quotationBackgroundShade, ...props }) => {
  const [quotationBackgroundOpacity, setQuotationBackgroundOpacity] = useState(1);
  const [quotationOverlayOpacity, setQuotationOverlayOpacity] = useState(0);

  const calcQuotationOverlayOpacity = (percentage: number) => {
    const newPercentage = percentage * 2;
    const overlayOpacity = (newPercentage > 1 ? 1 : newPercentage);
    const backgroundOpacity = 1 - (overlayOpacity * 0.3);
    setQuotationBackgroundOpacity(backgroundOpacity);
    setQuotationOverlayOpacity(overlayOpacity);
  };

  const quotationDetails: IQuotation = {
    name: content.name,
    title: content.title,
    quotation: <span>{content.quotation}</span>,
  };

  const quotationBackgroundOverlayStyles = {
    opacity: quotationOverlayOpacity,
  };

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  const backgroundWrapperStyles = {
    opacity: animateInSpring.active.to(x => x * quotationBackgroundOpacity),
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  return (
    <div
      ref={inViewRef}
      className={classNames(
        'quotationContentWrapper',
        { alignLeft: content.align === 'left' },
        { alignRight: content.align === 'right' },
      )}
    >
      <a.div className='quotationBackgroundWrapper' style={backgroundWrapperStyles}>
        <LazyImage
          width='100%'
          height='100%'
          src={'/assets/images/work/' + content.image.url}
          alt={content.image.alt}
          fit='cover'
          animateImageIn={true}
          animationType={'reveal'}
        />
        <div className='quotationBackgroundOverlay' style={quotationBackgroundOverlayStyles} />
      </a.div>
      <ScrollPercentage onChange={calcQuotationOverlayOpacity} >
        {({ percentage, ref, entry }) => (
          <div className='quotationBottomWrapper' ref={ref}>
            <div
              className='floatingQuotationWrapper'
            >
              <FullQuotation
                class={'projectQuotation'}
                viewportOffsets={{
                  top: 300,
                  bottom: 300,
                }}
                quotation={quotationDetails}
                sectionBackgroundShade={quotationBackgroundShade}
                quotationMarkColor={content.quotationMarkColor}
                personLineColor={content.personLineColor}
                animationReady={inView}
              />
            </div>
          </div>
        )}
      </ScrollPercentage>
    </div>
  );
};
